<div class="header__topbar" #headerElement cy-header-menu [ngClass]="{header__topbar_sticky: isScrolled()}">

  <div class="container-xxl container-fluid">
    <div class="row">
      <div class="col">

        <p-menubar [model]="items()">
          <ng-template #start>
            @if (startHeaderTemplate()) {
            <ng-template *ngTemplateOutlet="startHeaderTemplate()"></ng-template>
            } @else {
            <a href="#">
              <img class="header__start__logo" [imageDirective]="{
                src : 'assets/img/hamsaz-logo.svg'
              }">
            </a>
            }
          </ng-template>

          <ng-template #item let-item let-root="root">
            <!-- <div #itemsLink></div> -->
            @if(itemHeaderTemplate()) {
            <ng-template *ngTemplateOutlet="itemHeaderTemplate()"></ng-template>
            } @else {
            <a [href]=item.url [target]="item.target === 'blank' ? '_blank' : ''"
              class="flex align-items-center p-menuitem-link bg-white">
              <span class="font-M1-lg font-M1-md font-S-sm regular ml-2 bg-white muted_9" [attr.cy-label]="item.label">
                {{ item.label}}
              </span>
            </a>
            }

          </ng-template>

          <ng-template #end>
            @if(endHeaderTemplate()){
            <ng-template *ngTemplateOutlet="endHeaderTemplate()"></ng-template>
            } @else {
            <div class="d-flex gap-4 align-items-center">
              <div class="header__call" (click)="phoneCall()">
                <span class="font-M2-lg font-M2-md font-M2-sm bold">۰۳۵-۳۸۳۴۲۳۱۷</span>
                <i class="isax icon-call"></i>
              </div>
              <app-button-loader class="header__login_button" [button]="loginRegisterButton"></app-button-loader>
              <div class="d-flex align-items-center relative">
                @if(dashboardBtn()?.label && isAuthenticated()){
                <app-button-loader class="header__login_button" [button]="dashboardBtn()"></app-button-loader>
                }

                @if(opened()) {
                <div #panel class="tiered-menu-panel" [class.open]="opened()" [ngClass]="class"
                  [attr.aria-hidden]="!opened()" role="menu">
                  <ul class="tiered-menu-list">
                    @for(item of dropDownOptions(); track $index){
                    <li>
                      <ng-container *ngIf="item.separator">
                        <div class="tiered-separator"></div>
                      </ng-container>
                      @if(!item.separator){
                      <ng-container>
                        <a RouteNavigate [subRoute]="item.routerLink" class="tiered-item" role="menuitem"
                          (click)="hide(); item?.command?.()" [ngClass]="item.styleClass ? item.styleClass : ''"
                          [attr.cy-button]="item.label">
                          <div class="tiered-item-left d-flex align-items-center">
                            <span *ngIf="item.icon" class="tiered-item-icon" [class]="item.icon"></span>
                            <span class="tiered-item-label">{{ item.label }}</span>
                          </div>
                          <div class="tiered-item-right">
                            <ng-container *ngIf="item.templateRef">
                              <ng-container [ngTemplateOutlet]="item.templateRef"></ng-container>
                            </ng-container>
                          </div>
                        </a>
                      </ng-container>
                      }
                    </li>
                    }
                  </ul>
                </div>
                }

                <!-- <p-tieredMenu class="header__menu-dropdown" #menu [model]="dropDownOptions" [popup]="true">
                  <ng-template pTemplate="item" let-item>

                    @if (item?.separator) {
                    <div *ngIf="item.separator" class="p-menu-separator"></div>
                    }

                    @else {
                    <a RouteNavigate [subRoute]="item.routerLink"
                      class="p-menuitem-link d-flex align-items-end justify-content-between"
                      [attr.cy-button]="item.label">
                      <div class="d-flex align-items-center">
                        <span class="p-tieredmenu-item-icon" [class]="item.icon"></span>
                        <span class="p-menuitem-text">{{ item.label }}</span>
                      </div>
                      @if (item?.templateRef) {
                      <ng-container [ngTemplateOutlet]="item?.templateRef"></ng-container>
                      }
                    </a>
                    }
                  </ng-template>
                </p-tieredMenu> -->
              </div>
            </div>
            }
          </ng-template>
        </p-menubar>

      </div>
      <div class="header__navbar">
        @if(!buttonNavigateTemplate()){
        <div class="d-flex justify-content-center text-center">
          <a RouteNavigate class="font-XS-md font-XS-sm bold" [subRoute]="home" [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: false }">
            <i class="isax icon-home-2 mt-3"></i>
            <span>خانه</span>
          </a>

          <a class="font-XS-md font-XS-sm bold" (click)="navigateToPanel()">
            <i class="isax icon-user mt-3"></i>
            <span>حساب کاربری</span>
          </a>
        </div>
        } @else {
        <ng-template *ngTemplateOutlet="buttonNavigateTemplate()"></ng-template>
        }
      </div>

      <ng-template #walletPannelMenu>
        <span class="p-menuitem-text d-flex align-items-center bold me-3">
          {{(userWallet) | convertCurrency: 'rial' : 'toman' | number}} <span class="regular me-2 muted_6">تومان</span>
          <i class="isax icon-arrow-left-2 p-tieredmenu-item-icon"></i>
        </span>
      </ng-template>
      <ng-template #notificationPannelMenu>
        <p-badge [value]="notificationCount()" [attr.cy-content]="notificationCount()" severity="danger" />
      </ng-template>